exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".svg-icon[data-v-371849ee]{width:1em;height:1em;vertical-align:-.15em;fill:currentColor;overflow:hidden}", ""]);

